import { AiConfigureMenu } from './AiConfigureMenu';
// Design source of truth:
// - Inspection Assistant Review.dc.html (IP-14857) — labeled "Configure" button
// - AI Rules and Knowledge.dc.html (IP-14858) — icon-only widget header variant
const ITEMS = [
    { key: 'assistant-settings', label: 'Inspection Assistant Settings', href: '/ai_inspection_manager' },
    { key: 'rules-and-knowledge', label: 'AI Rules & Knowledge', href: '/tenant_knowledge_base' }
];
const meta = {
    title: 'Features/AiConfigureMenu',
    component: AiConfigureMenu,
    parameters: {
        docs: {
            description: {
                component: 'Admin-only Configure control shared by the Inspection Assistant Review screen and the IP Assistant chat widget header. Opens a QUI Popup listing the AI configuration destinations.'
            }
        }
    },
    args: {
        items: ITEMS,
        visible: true,
        variant: 'button',
        mode: 'light'
    },
    argTypes: {
        variant: { control: 'radio', options: ['button', 'icon'] },
        mode: { control: 'radio', options: ['light', 'dark'] },
        visible: { control: 'boolean' }
    }
};
export default meta;
/** Labeled "Configure" button — used on the review screen header. */
export const LabeledButton = {};
/** Icon-only trigger — used in the chat widget header top-right. */
export const IconVariant = {
    args: { variant: 'icon' }
};
/** Hidden for non-admins — renders nothing. */
export const HiddenForNonAdmin = {
    args: { visible: false }
};
